var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.xsOnly)?_c('XsRewards'):_c('div',[(_vm.hasPoints)?_c('RewardsPoints'):_vm._e(),(_vm.hasClubs)?_c('RewardsClubs'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }